<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h2 class="mb-3 text-primary mt-3">
              {{ 'dashboard.welcome-banner.title' | translate }}
            </h2>
            <p class="font-weight-bold">
              {{ 'dashboard.welcome-banner.subtitle' | translate }}
            </p>
            <p class="text-muted mt-4">
              {{
                'dashboard.welcome-banner.recommended-actions-text' | translate
              }}
            </p>
            <a
              href
              [routerLink]="['../../documents/o/add/invoice']"
              class="btn btn-outline-primary mb-3"
              >{{ 'button.create-new-invoice' | translate }}</a
            >
            <br />
            <a
              href
              [routerLink]="['../../clients', { add: true }]"
              class="btn btn-outline-secondary btn-sm mb-3"
              >{{ 'button.create-new-client' | translate }}</a
            >
            <br />
            <a
              href
              [routerLink]="['../../items', { add: true }]"
              class="btn btn-outline-secondary btn-sm mb-3"
              >{{ 'button.create-new-item-service' | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
